import { render, staticRenderFns } from "./BucketView.vue?vue&type=template&id=2fe545d2&scoped=true&"
import script from "./BucketView.vue?vue&type=script&lang=ts&"
export * from "./BucketView.vue?vue&type=script&lang=ts&"
import style0 from "./BucketView.vue?vue&type=style&index=0&id=2fe545d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe545d2",
  null
  
)

export default component.exports